import {
  InsertData
  
} from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import {
  ADD_PAYMENT ,
  UPDATE_PAYMENT ,
  DELETE_PAYMENT ,
  GET_PAYMENT, 
  GET_ALL_PAYMENT,
} from "../type";

//create new user
export const createPaymentAction = (data) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/add-payment/`, data);
    dispatch({
      type: ADD_PAYMENT,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: ADD_PAYMENT,
      payload: e.response,
    });
  }
};
export const deletePaymentAction = (data) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/delete-payment/`, data);
    dispatch({
      type: DELETE_PAYMENT,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: DELETE_PAYMENT,
      payload: e.response,
    });
  }
};
export const updatePaymentAction = (data) => async (dispatch) => {
  try {
    const response = await InsertData(`/api/update-payment-data/`, data);
    dispatch({
      type: UPDATE_PAYMENT,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: UPDATE_PAYMENT,
      payload: e.response,
    });
  }
};
export const GetAllPaymentAction = (data) => async (dispatch) => {
  try {
    const response = await GetDataToken(`/api/get-payments/`);
    dispatch({
      type: GET_ALL_PAYMENT,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: GET_ALL_PAYMENT,
      payload: e.response,
    });
  }
};
export const GetAllPaymentdataAction = (data) => async (dispatch) => {
  try {
    const response = await GetDataToken(`/api/get-payment-data/${data}/`);
    dispatch({
      type: GET_PAYMENT,
      payload: response,
      
    });
  } catch (e) {
    dispatch({
      type: GET_PAYMENT,
      payload: e.response,
    });
  }
};